import { createContext } from 'react';
import type { BrandConfig } from '../types/index.js';

export const BrandContext = createContext<BrandConfig | null>(null);
